module.exports = __webpack_public_path__ + "img/clock_test.8669c46d.png";